<template>
  <div
    class="sb-progress-bar-breakpoint"
  >
    <div>
      <!--
        @slot slot to show progress bar contents
      -->
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'SbProgressBarBreakPoint',
  inject: ['sbTimeline'],
  mounted() {
    this.sbTimeline.els.push(this.$el);
  },
};
</script>

<style lang="scss" scoped>
@import '@src/components/Timeline/style/sb-progress-bar-break-point.scss'
</style>
